import { V3Button } from "../Button"
import { V3ButtonColor } from "../Button/V3Button.types"
import { RightAlignPanel } from "../ReusableStyledComponents/RightAlignPanel"
import { VerticalSpacing } from "../VerticalSpacing"
import { OptionsWrapper } from './AddContentUpload.styles';
import { FadeInContainer } from '../ReusableStyledComponents/FadeIn';
import { V3CaptionGrey35 } from "../ReusableStyledComponents/V3CaptionGrey35"
import { RoundedBoxCTA, RoundedBoxCTAProps } from "./SharedComponents/RoundedBoxCTA";
import { V3Loader } from "../Loader";

interface UACGenericOptionsScreenProps {
    options: RoundedBoxCTAProps[],
    onBackHandler?: () => void,
    description?: string,
    useCol?: boolean,
    loading?: boolean
}

export const UACGenericOptionsScreen = ({ options, onBackHandler, useCol = false, description, loading = false }: UACGenericOptionsScreenProps) => {
    return <>
        <FadeInContainer>
            {
                !!description?.length && <VerticalSpacing bottom={32}>
                    <V3CaptionGrey35>{description}</V3CaptionGrey35>
                </VerticalSpacing>
            }
            <OptionsWrapper $useCol={useCol}>
                {
                    options.map((opt, index) => <RoundedBoxCTA
                        key={index}
                        text={opt.text}
                        onClick={opt.onClick}
                        href={opt.href}
                        disabled={opt.disabled}
                        customIcon={opt?.customIcon}
                        skipTargetBlank={opt?.skipTargetBlank}
                        secondaryText={opt?.secondaryText}
                        tooltip={opt.tooltip}
                    />)
                }
            </OptionsWrapper>
        </FadeInContainer>
        <VerticalSpacing top={24}>
            <RightAlignPanel>
                {
                    loading && <V3Loader height={42} />
                }
                {
                    !loading && !!onBackHandler && <div>
                        <V3Button
                            text="Back"
                            color={V3ButtonColor.secondary}
                            onClick={onBackHandler}
                        />
                    </div>
                }
            </RightAlignPanel>
        </VerticalSpacing>
    </>
}